import React, { Suspense } from 'react'
import { Header, Content, Footer, Container } from '@components/index'
import { Redirect, Route, Switch } from 'react-router-dom'
import 'snacks-design-system/lib/main.css'
import 'snacks-design-system/lib/theme.css'
import VerifyRoute from '@components/VerifyRoute'
import LoginApp from '@components/LoginApp'
import MagicLinkRoute from '@components/MagicLinkRoute'

const LandingRoute = () => {
  return (
    <Container>
      <Header />
      <Content />
      <Footer />
    </Container>
  )
}

const App = () => {
  return (
    <Suspense fallback={<div />}>
      <Switch>
        <Route path="/landing">
          <LandingRoute />
        </Route>
        <Route path="/verify-ocf">
          <VerifyRoute />
        </Route>
        <Route path="/magic-link">
          <MagicLinkRoute />
        </Route>
        <Route path="/login-app">
          <LoginApp />
        </Route>
        <Redirect from="*" to="/landing" />
      </Switch>
    </Suspense>
  )
}

export default App
